import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Chip } from '~/eds/src/components/Chip/Chip';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { User } from '~/eds/src/components/User/User';
import { TicketStatusType } from '~/enums/TicketStatusType';
import { withUsers } from '~/hocs/withUsers';
import { useIntl } from 'react-intl';
import { externalUserToUser } from '~/utils/user';

import TicketApprovalItem from '../TicketApprovalItem/TicketApprovalItem';

const TicketRecipientsList = ({
  recipients,
  // connected props
  users,
  approvals,
}) => {
  const intl = useIntl();
  const getUnknownUser = () => {
    return {
      name: '',
      email: '',
    };
  };

  const getCC = ({ recipient, user }) => (
    <Layout
      key={recipient.id}
      align="center"
      spacing={4}
      p={4}
      styles={{ border: 'border', borderRadius: 'm' }}
    >
      <User
        info={user ? user.email : ''}
        user={user ? user : getUnknownUser()}
      />
      <Chip
        text={intl.formatMessage({
          id: 'TicketRecipientsList.ccLabel',
          defaultMessage: 'CC',
          description: 'Label for CC (carbon copy) recipients in ticket',
        })}
        variant="info"
      />
    </Layout>
  );

  return recipients.map((recipient) => {
    const approvalItem =
      recipient.approvalIds && recipient.approvalIds.length
        ? approvals[recipient.approvalIds[0]]
        : null;
    if (!approvalItem) {
      let { userId, email, name } = recipient;
      let user = userId ? users[userId] : externalUserToUser({ name, email });
      return getCC({ recipient, user });
    } else if (approvalItem.status === TicketStatusType.NotApplicable) {
      const approvalItem = approvals[recipient.approvalIds[0]];
      const userId = approvalItem.userId;
      const externalUser = approvalItem.externalUser;
      const user = !!externalUser
        ? externalUserToUser(externalUser)
        : users[userId];
      return (
        <Layout
          key={recipient.id}
          align="center"
          spacing={4}
          p={4}
          styles={{ border: 'border', borderRadius: 'm' }}
        >
          <User
            info={user ? user.email : ''}
            user={user ? user : getUnknownUser()}
          />
          <Chip
            text={intl.formatMessage({
              id: 'TicketRecipientsList.ccLabel',
              defaultMessage: 'CC',
              description: 'Label for CC (carbon copy) recipients in ticket',
            })}
            variant="info"
          />
        </Layout>
      );
    } else {
      return recipient.approvalIds.map((approvalId) => {
        return (
          <TicketApprovalItem
            issueId={recipient.id}
            entityType={recipient.entityType}
            approvalId={approvalId}
            approvalName={recipient.name}
            key={recipient.id}
          />
        );
      });
    }
  });
};

TicketRecipientsList.propTypes = {
  recipients: PropTypes.array.isRequired,
};

function mapStateToProps({ ticket }) {
  const { approvals } = ticket;
  return approvals;
}

export default connect(mapStateToProps)(withUsers(TicketRecipientsList));
